<form [formGroup]="tariffForm" class="tariff-form" *ngIf="tariffForm">
  <div class="form-title" translate>common.information</div>
  <div class="ui-kit-layout-columns-2" *ngIf="_tariff" data-qa-block="tariff">
    <div translate data-qa="tariff-title">tariffs.subscribe</div>
    <div class="tariff-info">
      <span data-qa="tariff-name">{{ _tariff.name }}</span>
      <span class="ui-kit-grey-text" data-qa="tariff-price">
        {{ _tariff | tariffPrice | kzCurrency }}
        {{ 'tariffs.period.MONTH' | translate }}
      </span>
    </div>
  </div>

  <div class="ui-kit-layout-columns-2" data-qa-radio-list="connection-type">
    <div data-qa="radio-input-name" class="required-marker">
      {{ 'tariffs.connection.type' | translate }}
    </div>

    <div class="connection-type" data-qa="radio-list-items">
      <div class="input-item" data-qa-radio="wired">
        <label class="radio">
          <input data-qa="radio" type="radio" formControlName="connectionType" value="WIRED" />
          <span data-qa="label-text">{{ 'tariffs.connection.type.wired' | translate }}</span>
          <span class="checkmark"></span>
        </label>
      </div>

      <div class="input-item" data-qa-radio="wireless">
        <label class="radio">
          <input data-qa="radio" type="radio" formControlName="connectionType" value="WIRELESS" />
          <span data-qa="label-text">{{ 'tariffs.connection.type.wireless' | translate }}</span>
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
  <tax-input
    taxNumbersOnly
    data-qa-input="sim-number"
    id="sim"
    formControlName="simNumber"
    name="simNumber"
    placeholder="0123456789"
    labelText="modal.sim.title"
    inputStyles="max-width: 256px"
    [tabindex]="1"
    [layoutColumns]="2"
    [maxlength]="25"
    [autofocus]="true"
    [clearable]="true"
  ></tax-input>
  <tax-input
    data-qa-input="promo-code"
    formControlName="promoCode"
    labelText="tariff.select.promo.code.label"
    inputStyles="max-width: 350px"
    mask="AAAAA-AAAAA-AAAAA-AAAAA-AAAAA"
    [tabindex]="2"
    [layoutColumns]="2"
    [clearable]="true"
  ></tax-input>
  <tax-phone-input
    data-qa-input="consultant-phone"
    formControlName="consultantPhone"
    labelText="tariff.select.consultant.label"
    inputStyles="max-width: 250px"
    [tabindex]="3"
    [layoutColumns]="2"
    [clearable]="true"
    [allowKzPhoneOnly]="true"
  ></tax-phone-input>
</form>
